import { render, staticRenderFns } from "./userArea_item_dialog.vue?vue&type=template&id=e5a6b47c"
import script from "./userArea_item_dialog.vue?vue&type=script&lang=js"
export * from "./userArea_item_dialog.vue?vue&type=script&lang=js"
import style0 from "./userArea_item_dialog.vue?vue&type=style&index=0&id=e5a6b47c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports